import Promise from 'bluebird'

import tablelistApi from 'api/tablelistApi'
import storageLib from 'lib/storage'

export default {
  send(name, options) {
    if (!name) return Promise.reject(new Error('name'))
    if (!options) return Promise.reject(new Error('options'))

    const sessionToken = storageLib.getSessionToken()

    const data = {
      sessionId: sessionToken,
      event: name,
      data: options,
    }

    data.context = {
      userAgent: navigator.userAgent,
      page: {
        href: window.location.href,
        protocol: window.location.protocol,
        host: window.location.host,
        hostName: window.location.hostname,
        port: window.location.port,
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        title: document.title,
        referrer: document.referrer,
      },
    }

    return tablelistApi.post('/track', data)
  },
}



// WEBPACK FOOTER //
// ./src/api/track/service.js